(function () {
    'use strict';

    angular
        .module('app')
        .directive('bgImageSrcSet', bgImageSrcSet);

    bgImageSrcSet.$inject = ['$window'];

    function bgImageSrcSet($window) {
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope) {
            function responsiveBackgroundImage(element) {
                var item = {};

                var version = detectIE();

                var update = function () {
                    let src = version <= 11 ? item.img.src : item.img.currentSrc || item.img.src;
                    if (item.src !== src) {
                        item.src = src;
                        item.element.style.backgroundImage = 'url("' + item.src + '")';

                    }
                }

                item.element = element;
                item.img = element.querySelector('img');
                item.src = '';

                item.img.addEventListener('load', function () {
                    update();
                });

                if (item.img.complete) {
                    update();
                }
            }

            let elements = document.querySelectorAll('.bg-responsive-image');
            for (let i = 0; i < elements.length; i++) {
                responsiveBackgroundImage(elements[i]);
            }

            function detectIE() {
                var ua = window.navigator.userAgent;

                // Test values; Uncomment to check result …

                // IE 10
                // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

                // IE 11
                // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

                // Edge 12 (Spartan)
                // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

                // Edge 13
                // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

                var msie = ua.indexOf('MSIE ');
                if (msie > 0) {
                    // IE 10 or older => return version number
                    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                }

                var trident = ua.indexOf('Trident/');
                if (trident > 0) {
                    // IE 11 => return version number
                    var rv = ua.indexOf('rv:');
                    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                }

                var edge = ua.indexOf('Edge/');
                if (edge > 0) {
                    // Edge (IE 12+) => return version number
                    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                }

                // other browser
                return false;
            }
        }
    }

})();





//////////////////
// WEBPACK FOOTER
// ./static/common/js/directives/_bgImageSrcSet.js
// module id = 14
// module chunks = 0